import React, { useEffect, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import { useHistory } from 'react-router';
import api from '../seller-apis/api';
import { fetchAllNotifications } from '../seller-apis/apidataField';
import PaginationCom from './common/Pagination';


function Notification() {

  let history = useHistory();

  const [notiList, setnotiList] = useState([])

   // Pagination related

   const [selectedPage, setSelectedPage] = useState();
   const [totalrecords, setTotalRecords] = useState();
 
   //  Loader
 
   const [ennewloader, setennewloader] = useState();

  useEffect(() => {
    setennewloader("none")
    let data = {
      "pageNo": "1"
    }
    api.notify.fetchNotifications(fetchAllNotifications(data)).then(res => {
      setnotiList(res.data)
      setTotalRecords(res.totalRecords)
    }).catch(err => console.log(err))
  }, [])

  function paginate(data){
    let outerdiv = document.getElementById("outer");
    let loaderDiv = document.getElementById("enNewLoader");
    outerdiv.classList.add("div-bk");
    loaderDiv.classList.add("loader-bt");
    setennewloader("block")
    let filterData = {
      "pageNo": data.number
    }
    api.notify.fetchNotifications(fetchAllNotifications(filterData)).then(res => {
      setnotiList(res.data)
      setennewloader("none")
      outerdiv.classList.remove("div-bk");
      loaderDiv.classList.remove("loader-bt");
    }).catch(err => console.log(err))
  }


  return (
    <div id="outer">
    <div className="page-bg">
      <section>
        <div className="py-3 my-3 back-head-nospc bg-theme text-white"><span onClick={()=>history.push('/home')}><i className="fa fa-arrow-left mx-3"></i> </span>Notification</div>
        <Container>

          {notiList.length > 0 && notiList.map((item, index) => {
             let date = new Date(item.updatedAt);
             let d = date.toDateString(item.updatedAt);
             let newd = d.substr(4)
            return (
              <Row className="f-600 card card1 m-1 d-flex py-2" key={index}>
                <div className="col-12">

                  <span className="fs-14" >{item.notes}</span>
                  <p className="text-danger mb-0 text-end fs-14">{newd}</p>

                </div>
              </Row>
            )
          })}

        </Container>
      </section>


      </div>
      <div class="d-flex justify-content-center" id="enNewLoader" >
          <div class="spinner-border" role="status" style={{ "display": ennewloader }}>
            <span class="sr-only"></span>
          </div>
        </div>
        <PaginationCom
          number={totalrecords}
          paginate={paginate}
          comp="notification"
        />
    </div>
  )

}

export default Notification;